import {API} from "@/api/backend";

const state = {
  items: [],
  itemsToAdd: [],
  postStatus: null,
  errorMessage: '',
}

const mutations = {
  setItems(state, payload = []) {
    state.items = [ ...payload ]
  },
  setItemsToAdd(state, payload = []) {
    state.itemsToAdd = [...payload]
  },
  setPostStatus(state, status) {
    state.postStatus = status;
  },
  setErrorMessage(state, message) {
    state.errorMessage = message
  },
}

const actions = {
  async getMediaItems({commit}){
    try {
      const resp = await API.get('/media-objects?itemsPerPage=199')
      console.log(resp.data)
      const images = resp.data['hydra:member'].map( photo => photo.image )
      console.log(images)
      commit('setItems', images )
    } catch (e) {
      console.error(e)
    }
  },
  async submitNewItems({rootState, state, commit, dispatch }) {
    try {
      let formData = new FormData()

      state.itemsToAdd.forEach( item => {
        formData.append('file', item)
        formData.append('type', 'picture')
        formData.append('object', 'Product')
      })

      try {
        await API.post(`/media-objects`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${rootState.Auth.token}`
          }
        })
      } catch (e) {
        console.log(e)
      }
      commit('setPostStatus', 'success');
      commit('setItemsToAdd')
      dispatch('getMediaItems')
      return true
    } catch (e) {
      commit('setPostStatus', 'error');
      commit('setErrorMessage', e.response.data['hydra:description'])
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
